/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// react-router components
import { Routes, Route } from "react-router-dom";

// Material Dashboard 2 React routes
import RouteGuard from "../../route.guard";
import useRoutes from "./routes";

export default function IntegrationApp() {
  const routes = useRoutes()
  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }
      if (route.guard) {
        const { valid, redirect, state } = route.guard;
        return (
          <Route
            element={
              <RouteGuard valid={valid} redirect={redirect} state={state} />
            }
            key={route.key}
          >
            <Route exact path={route.route} element={route.component} />
          </Route>
        );
      }

      if (route.route) {
        return (
          <Route
            exact
            path={route.route}
            element={route.component}
            key={route.key}
          />
        );
      }

      return null;
    });

  return (
    <Routes>
      {getRoutes(routes)}
    </Routes>
  );
}
